module.exports = __webpack_public_path__ + "static/img/16.8daa163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customerCarousel/16.png
// module id = MT2T
// module chunks = 7